import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-xl border border-sand p-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-serif font-semibold text-primary-800 mb-6" }, " Create a New Proposal ", -1)
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, " Title ", -1)
const _hoisted_5 = {
  key: 0,
  class: "mt-1 text-sm text-red-600"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, " Category ", -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<option value=\"\" disabled>Select a category</option><option value=\"maintenance\">Maintenance</option><option value=\"improvement\">Improvement</option><option value=\"policy\">Policy Change</option><option value=\"event\">Event</option><option value=\"financial\">Financial</option><option value=\"other\">Other</option>", 7)
const _hoisted_14 = [
  _hoisted_7
]
const _hoisted_15 = {
  key: 0,
  class: "mt-1 text-sm text-red-600"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, " Description ", -1)
const _hoisted_17 = {
  key: 0,
  class: "mt-1 text-sm text-red-600"
}
const _hoisted_18 = { class: "bg-blue-50 border border-blue-100 rounded-lg p-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-blue-800 mb-2" }, " Support Threshold ", -1)
const _hoisted_20 = { class: "flex items-center gap-3 mb-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-blue-700" }, "households to reach threshold", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-blue-600" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "How it works:"),
  /*#__PURE__*/_createTextVNode(" After you submit, other neighbors can \"support\" your proposal. Once you reach this number of supporters, your proposal becomes eligible for a formal HOA vote. We recommend 10-15 to show genuine community interest. ")
], -1)
const _hoisted_23 = { class: "flex justify-end gap-3 pt-4 border-t border-sand" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "text-sm text-red-600"
}

import { ref, reactive } from "vue";
import { useProposalStore } from "@/stores/proposals";


export default /*#__PURE__*/_defineComponent({
  emits: ["created", "cancel"],
  setup(__props, { emit }) {



const proposalStore = useProposalStore();

const form = reactive<NewProposal>({
  title: "",
  description: "",
  category: "" as ProposalCategory,
  support_threshold: 10,
});

const errors = reactive({
  title: "",
  description: "",
  category: "",
});

const submitting = ref(false);
const submitError = ref("");

const validate = (): boolean => {
  let valid = true;

  errors.title = "";
  errors.description = "";
  errors.category = "";

  if (!form.title.trim()) {
    errors.title = "Title is required";
    valid = false;
  } else if (form.title.length > 255) {
    errors.title = "Title must be 255 characters or less";
    valid = false;
  }

  if (!form.description.trim()) {
    errors.description = "Description is required";
    valid = false;
  }

  if (!form.category) {
    errors.category = "Please select a category";
    valid = false;
  }

  return valid;
};

const submitProposal = async () => {
  if (!validate()) return;

  submitting.value = true;
  submitError.value = "";

  try {
    const proposal = await proposalStore.createProposal(form);
    emit("created", proposal);

    // Reset form
    form.title = "";
    form.description = "";
    form.category = "" as ProposalCategory;
    form.support_threshold = 10;
  } catch (err: any) {
    submitError.value =
      err?.response?.data?.error ||
      "Failed to create proposal. Please try again.";
  } finally {
    submitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _withModifiers(submitProposal, ["prevent"]),
      class: "space-y-5"
    }, [
      _createElementVNode("div", null, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).title) = $event)),
          type: "text",
          placeholder: "What's your proposal about?",
          class: _normalizeClass(["w-full px-4 py-3 border border-sand rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-transparent", { 'border-red-500': _unref(errors).title }]),
          maxlength: "255"
        }, null, 2), [
          [_vModelText, _unref(form).title]
        ]),
        (_unref(errors).title)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(errors).title), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).category) = $event)),
          class: "w-full px-4 py-3 border border-sand rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-transparent bg-white"
        }, _hoisted_14, 512), [
          [_vModelSelect, _unref(form).category]
        ]),
        (_unref(errors).category)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(errors).category), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _hoisted_16,
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).description) = $event)),
          rows: "5",
          placeholder: "Describe your proposal in detail. What problem does it solve? What are the benefits?",
          class: _normalizeClass(["w-full px-4 py-3 border border-sand rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-transparent resize-none", { 'border-red-500': _unref(errors).description }])
        }, null, 2), [
          [_vModelText, _unref(form).description]
        ]),
        (_unref(errors).description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_unref(errors).description), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).support_threshold) = $event)),
            type: "number",
            min: "1",
            max: "166",
            class: "w-24 px-4 py-3 border border-blue-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-transparent bg-white"
          }, null, 512), [
            [
              _vModelText,
              _unref(form).support_threshold,
              void 0,
              { number: true }
            ]
          ]),
          _hoisted_21
        ]),
        _hoisted_22
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('cancel'))),
          class: "px-6 py-3 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors"
        }, " Cancel "),
        _createElementVNode("button", {
          type: "submit",
          disabled: submitting.value,
          class: "px-6 py-3 text-sm font-medium text-white bg-accent-700 rounded-lg hover:bg-accent-800 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
        }, _toDisplayString(submitting.value ? "Submitting..." : "Submit Proposal"), 9, _hoisted_24)
      ]),
      (submitError.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(submitError.value), 1))
        : _createCommentVNode("", true)
    ], 40, _hoisted_3)
  ]))
}
}

})